import { render } from "./ApprovalProcessTypeTable.vue?vue&type=template&id=1812c4e4&scoped=true"
import script from "./ApprovalProcessTypeTable.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessTypeTable.vue?vue&type=script&lang=js"

import "./ApprovalProcessTypeTable.vue?vue&type=style&index=0&id=1812c4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1812c4e4"]])

export default __exports__